import BFF from '@/services/BFF';

const getInitialProps = async (ctx) => {
  const { categories } = await BFF.getFaqs(ctx)();

  return {
    ...(await BFF.getAppSettings(ctx)()),
    categories,
  };
};

export default getInitialProps;
